import { Cpu, Zap, Box, Factory, ShieldCheck } from "lucide-react";

export const PRODUCT_SCOPE = [
  {
    title: "E-Houses & Switchgear",
    subtitle: "Integrated Power Distribution",
    icon: Cpu,
    img: "https://res.cloudinary.com/dc912sjxj/image/upload/v1768330248/E-House_E-Pod_Art_Genpower_Solutions_Ltd_ESI_02_kq90fj.webp",
  },
  {
    title: "Acoustic Enclosures",
    subtitle: "Noise Suppression Systems",
    icon: Zap,
    img: "https://res.cloudinary.com/dc912sjxj/image/upload/v1768329341/Art_Genpower_Solutions_Ltd_ESI_Container_02_axoz6j.webp",
  },
  {
    title: "Custom Fuel Systems",
    subtitle: "Critical Supply & Management",
    icon: Box,
    img: "https://res.cloudinary.com/dc912sjxj/image/upload/v1768331854/Pump_Skids_and_Chemical_Injection_Art_Genpower_Solutions_Ltd___ESI_03_jdh8w1.webp",
  },
];

export const CORE_TENETS = [
  {
    icon: Cpu,
    title: "Bespoke Engineering",
    desc: "Specializing in E-Houses, power modules, and custom generator packaging tailored to extreme industrial specs.",
  },
  {
    icon: Factory,
    title: "Global Production",
    desc: "Leveraging high-capacity manufacturing terminals to deliver large-scale infrastructure across UK and Europe.",
  },
  {
    icon: ShieldCheck,
    title: "QA Compliance",
    desc: "Every project undergoes rigorous Factory Acceptance Testing (FAT) to ensure ISO-certified reliability.",
  },
];

export const PLACEHOLDER_IMG =
  "https://res.cloudinary.com/dc912sjxj/image/upload/b_white,f_auto,q_auto,c_pad,w_700,h_500/v1773164178/agp-placeholder-logo_uke2bq.webp";
